module.exports = __webpack_public_path__ + "static/media/fightscout-mobile-screens.200912b3.png";